import request from './request'

export function getEmailConfig() {
  return request.get('/mes/email/config')
}
export function saveEmailConfig(data) {
  return request.post('/mes/email/config', data)
}
export function testEmailConfig(email) {
  return request.post('/mes/email/config/test', { email })
}
export function listEmailRecipient(data) {
  return request.post('/mes/email/recipients/list', data)
}
export function getEmailRecipient(id) {
  return request.get('/mes/email/recipients/' + id)
}
export function saveEmailRecipient(data) {
  return request.post('/mes/email/recipients', data)
}
export function updateEmailRecipient(data) {
  return request.post('/mes/email/recipients/update', data)
}
export function deleteEmailRecipient(ids) {
  return request.post('/mes/email/recipients/delete', ids)
}
export function listEmailTemplate(data) {
  return request.post('/mes/email/templates/list', data)
}
export function getEmailTemplate(id) {
  return request.get('/mes/email/templates/' + id)
}
export function saveEmailTemplate(data) {
  return request.post('/mes/email/templates', data)
}
export function updateEmailTemplate(data) {
  return request.post('/mes/email/templates/update', data)
}
export function deleteEmailTemplate(ids) {
  return request.post('/mes/email/templates/delete', ids)
}
export function listEmailLog(data) {
  return request.post('/mes/email/logs/list', data)
}
